import { createRouter, createWebHistory } from 'vue-router'
import { routes } from 'vue-router/auto-routes'
import { useSessionsStore } from '@/stores/sessions'
import { usePlayerStore } from '@/stores/player'
import { useAuthStore } from '@/stores/auth'

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes
})

router.beforeEach(async (to, from, next) => {
    const authStore = useAuthStore()
    const sessionsStore = useSessionsStore()
    await authStore.checkAuth()

    // Protect admin routes
    if (to.path.startsWith('/admin')) {

        if (!authStore.isAuthenticated) {
            // If not authenticated, redirect to admin login
            if (to.path !== '/admin') {
                return next('/admin')
            }
        }
    }

    // Secure session routes
    if (to.path.startsWith('/session/') && to.params.pinCode) {
        const session = await sessionsStore.setCurrentSessionByPin(to.params.pinCode as string)
        if (!session) {
            return next('/404')
        }

        // Player registration redirect logic
        const playerStore = usePlayerStore()

        // If going to /register and already registered for this session, redirect to /play
        if (
            to.name === '/session/[pinCode]/register' &&
            playerStore.player.name &&
            playerStore.player.sessionId === session!.id
        ) {
            return next(`/session/${to.params.pinCode}/`)
        }

        // if going to /present and not authenticated, redirect to /admin
        if (
            to.name === '/session/[pinCode]/present' &&
            !authStore.isAuthenticated
        ) {
            return next(`/admin`)
        }
        if (
            to.name === '/session/[pinCode]/ranking' &&
            !authStore.isAuthenticated
        ) {
            return next(`/admin`)
        }

        // if going to /register and already registered for this session, redirect to /play
        if (
            to.name.toString().startsWith('/session/[pinCode]') &&
            to.name !== '/session/[pinCode]/register' &&
            to.name !== '/session/[pinCode]/present' &&
            to.name !== '/session/[pinCode]/ranking' &&
            (!playerStore.player.name ||
                playerStore.player.sessionId !== session!.id)
        ) {
            return next(`/session/${to.params.pinCode}/register`)
        }


    }
    next()
})

export default router
